import Tabs, { Tab, TabContext, TabHeader } from "./Tabs";

export default Tabs;

export {
    TabContext,
    TabHeader,
    Tab,
};
